const config = {
    apiKey: 'AIzaSyDv7ytRldFH9eukjWKMIGllz_KIlHhnXbI',
    authDomain: 'truckdesk-prototype.firebaseapp.com',
    databaseURL: 'https://truckdesk-prototype-default-rtdb.firebaseio.com',
    projectId: 'truckdesk-prototype',
    storageBucket: 'truckdesk-prototype.appspot.com',
    messagingSenderId: '248998912285',
    appId: "1:248998912285:web:b6eec89715fd921d3001f4",
    measurementId: "G-P5F183X2C0"
}

export default config